import * as React from "react";
import { useContext } from "react";

export const DisabledPropertyContext = React.createContext<boolean | undefined>(undefined);

export function useDisabledProperty(): boolean | undefined {
    const context = useContext(DisabledPropertyContext);
    return context;
}
